import React, { ReactElement, ReactNode } from 'react'

import Box from '@mui/material/Box'
import { extendSxProp } from '@mui/system'


interface Props {
    children?: ReactNode,
    sx?: object
}

export default function AbsoluteCenter({ sx, children }: Props): ReactElement {

    return (
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                ...sx
            }}>
            {children}
        </Box>
    )
}
